import { useFetchFromServer } from '../../../core/ui/utils/useFetchFromServer';

/**
 * @deprecated Use React Query instead. For more info, see here: https://bit.ly/3u0WlF7
 */
export function useRoles() {
  const {
    state: { data, isLoading, isError, error },
  } = useFetchFromServer({ url: '/roles' });
  return { rolesData: data, isRolesLoading: isLoading, isRolesError: isError, rolesError: error };
}
